import { Component, inject } from '@angular/core';
import { ModalController, IonButton, IonIcon } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'dispute-confirmation-popup',
  templateUrl: './dispute-confirmation-popup.component.html',
  styleUrls: ['./dispute-confirmation-popup.component.scss'],
  standalone: true,
  imports: [
    IonButton,
    IonIcon,
    TranslateModule,
  ]
})
export class DisputeConfirmationPopupComponent {
  private readonly modalController = inject(ModalController);

  protected async onCloseClick(): Promise<void> {
    await this.modalController.dismiss({isConfirmed: false});
  }

  protected async onOkClick(): Promise<void> {
    await this.modalController.dismiss({isConfirmed: true});
  }
}
